"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseInsensitiveIngest = void 0;
var class_transformer_1 = require("class-transformer");
var change_case_1 = require("change-case");
var storage_1 = require("class-transformer/cjs/storage");
var isCaseInsensitiveKeyMatch = function (propKey, exposeKey) { return function (ingestKey) {
    var ikLower = ingestKey.toLowerCase();
    var ikSnake = (0, change_case_1.snakeCase)(ingestKey).toLowerCase();
    return ((exposeKey && (ikLower === exposeKey.toLowerCase() || ikSnake === (0, change_case_1.snakeCase)(exposeKey))) ||
        ikLower === propKey.toLowerCase() ||
        ikSnake === (0, change_case_1.snakeCase)(propKey));
}; };
function CaseInsensitiveIngest() {
    return (0, class_transformer_1.Transform)(function caseInsensitiveIngest(_a) {
        var _this = this;
        var _b, _c, _d, _e, _f;
        var obj = _a.obj, key = _a.key, value = _a.value, options = _a.options;
        if (value) {
            return value;
        }
        var dms = storage_1.defaultMetadataStorage;
        var exposeMetadatas = dms.getExposedMetadatas(this.target);
        var exposeMatch = (_b = exposeMetadatas.find(function (em) { return em.propertyName === key; })) === null || _b === void 0 ? void 0 : _b.options.name;
        var keyMatch = Object.keys(obj).find(isCaseInsensitiveKeyMatch(key, exposeMatch));
        if (keyMatch) {
            var matchedValue = obj[keyMatch];
            var typeMetadatas = (_d = (_c = __spreadArray([], __read(dms._typeMetadatas), false).find(function (tm) { return tm[0] === _this.target; })) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : new Map();
            var typeMatch_1 = (_f = (_e = typeMetadatas.get(key)) === null || _e === void 0 ? void 0 : _e.typeFunction) === null || _f === void 0 ? void 0 : _f.call(_e);
            if (typeMatch_1 && typeof matchedValue === 'object' && matchedValue !== null) {
                if (Array.isArray(matchedValue)) {
                    matchedValue = matchedValue.map(function (mv) { return (0, class_transformer_1.plainToInstance)(typeMatch_1, mv, options); });
                }
                else {
                    matchedValue = (0, class_transformer_1.plainToInstance)(typeMatch_1, matchedValue, options);
                }
            }
            return matchedValue;
        }
    }, {
        toClassOnly: true,
    });
}
exports.CaseInsensitiveIngest = CaseInsensitiveIngest;
//# sourceMappingURL=case-insensitive-ingest.js.map